import './AdminHeader.css';
import { useHistory } from 'react-router-dom';
import Navbar from 'react-bootstrap/Navbar';
import { BoxArrowRight } from 'react-bootstrap-icons';
import Button from 'react-bootstrap/Button';
import LogOutButton from '../LogOutButton/LogOutButton';
import { useSelector, useDispatch } from 'react-redux';

function AdminHeader() {
      const dispatch = useDispatch();
    return (
        <Navbar sticky="top" bg="primary" expand="lg" className="d-flex justify-content-between flex-md-nowrap p-0 shadow">
            <a className="d-flex justify-content-center navbar-brand col-md-2 col-lg-2 md-0 px-2 py-2" onClick={history.go}>
                <img src="images/fmrrv-header.png" height="49px" width="78px" alt="logo" /></a>
            <ul className="navbar-nav px-3">
                <li className="nav-item text-nowrap">
                    <Button  onClick={() => dispatch({ type: 'LOGOUT' })} variant="outline-light">LOG OUT</Button>
                </li>
            </ul>
        </Navbar >
    );
}

export default AdminHeader;